import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { getBankAccountList } from '../../../helper/Api';
import { FaRegEdit } from "react-icons/fa"
import { Link } from 'react-router-dom';

const ChildAccountList = (filterDate) => {
    const { authData } = useSelector((state) => state.authData);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState([]);


    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };

    const columns = [
        {
            name: 'Department Name',
            selector: (row) => row.name,
            sortable: true,
            width: "180px",
            right:false,
        },
        {
            name: 'Department Code',
            selector: (row) => row.code,
            sortable: true,
            width: "180px",
            right: false
        },
        {
            name: 'Department Level',
            selector: (row) => row.department_level,
            sortable: true,
            width: "180px",
            right: false
        },
        {
            name: 'Account Name',
            selector: (row) => row.account_name,
            sortable: true,
            width: "400px",
            right: false
        },
        {
            name: 'Account No',
            selector: (row) => row.account_no,
            sortable: true,
            width: "180px",
            right: false
        },
        {
            name: 'Account Balance',
            selector: (row) => row.account_balance,
            sortable: true,
            width: "180px",
            right: false
        },
        {
            name: 'Balance As On',
            selector: (row) => row.balance_date,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'Interest Date',
            selector: (row) => row.interest_date,
            sortable: true,
            width: "150px",
            right: false
        },
        {
            name: 'Quarter',
            selector: (row) => row.quarter,
            sortable: true,
            right: false
        }
    ];

    if(authData.user.user_type === 'l3') {
        columns.push({
            name: 'Actions',
            cell: (row) => (
                <div className='user_action'>
                    <Link to={`/editChildAccount/${row.id}`}><FaRegEdit /></Link>
                </div>
            ),
            width: "200px",
            right: false
        });
    }

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1);
    };
    const fetchList = async () => {
        try {
            const resp = await getBankAccountList({
                tier: filterDate.tier,
                searchStr: filterDate.searchStr,
                department_id: (authData.user.department_id !== "1") ? authData.user.department_id : null,
            });
            if (resp.data.status) {
                setData(resp.data.result);
            }
        } catch (error) {
            setData([]);
        }
    }
    useEffect(() => {
        fetchList();
    }, [filterDate.searchStr, filterDate.tier])
    return (
        <div>
            <DataTable
                customStyles={customStyles}
                className="dataTables_wrapper"
                columns={columns}
                data={data}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                pagination
                paginationPerPage={rowsPerPage}
                paginationTotalRows={data.length}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </div>
    )
}
export default ChildAccountList
